import { create } from 'zustand'
import { type LayoutNode } from '@backend/lib/db/typeRoots/layoutNode'

type NodeClipboardStore = {
  clipboardNodes: LayoutNode[]
  // Identifies the exact canvas the nodes were copied from (`${workspaceId}:${mediaIndex}`),
  // so paste can tell whether it's landing on the same canvas (offset to avoid
  // exact overlap) or a different one (keep the exact position). A workspace can
  // hold several canvases, so workspace id alone is too coarse.
  sourceCanvasKey: string | null
  setClipboard: (nodes: LayoutNode[], sourceCanvasKey: string) => void
  clearClipboard: () => void
}

// In-memory clipboard for canvas nodes. It lives outside React (like nodeStore)
// so a copy survives navigation between design pages / workspaces within the same
// session, which is what enables paste-across-canvas. Deliberately not the system
// clipboard: we only move nodes within the app, and this avoids clobbering the
// user's OS clipboard or fighting native text paste.
export const nodeClipboardStore = create<NodeClipboardStore>((set) => ({
  clipboardNodes: [],
  sourceCanvasKey: null,
  setClipboard: (nodes, sourceCanvasKey) => set({ clipboardNodes: nodes, sourceCanvasKey }),
  clearClipboard: () => set({ clipboardNodes: [], sourceCanvasKey: null }),
}))
